// all variables
const selectors = {
  errorApiMessage: 'Sorry, our stockist finder is currently unavailable, please try again later.',
  errorAutocomplete: 'Sorry, please select a place from the list',
  errorBrowserGeolocation: 'eolocation is not supported by this browser.',
  errorGeolocation: 'Sorry, you need to enable location sharing',
  errorGeometry: 'Sorry, please select a place from the list',
  errorMessage: 'Sorry, we couldnt find any stockists near that location.',
  findStockistsButton: '.productStockist__contentFormButton',
  form: '.productStockist__contentForm',
  geoLocationTitle: 'Current Location',
  pacError: '.productStockist__contentError',
  pacInput: '.productStockist__contentFormInput',
  pacInputIcon: '.productStockist__contentFormInputIcon',
  resetButton: '.productStockist__resultButton--reset',
  result: '.productStockist__result',
  resultButton: '.productStockist__resultButton--view',
  resultList: '.productStockist__resultList',
  resultListCard: '.productStockist__resultListCard',
  stockist: '.productStockist',
  stockistCount: '.productStockist__resultHeaderTitleCount',
  stockistsPage: '/pages/stockists',

  pacInputIconActiveClass: 'productStockist__contentFormInputIcon--active',
  resultActiveClass: 'productStockist__result--active',
  resultClass: 'productStockist__result',
  resultListCardActiveClass: 'productStockist__resultListCard--active',
  resultListCardClass: 'productStockist__resultListCard',
  resultListCardCountClass: 'productStockist__resultListCardCount',
  stockistActiveClass: 'productStockist--active',
  stockistErrorClass: 'productStockist--error'
};

// declare element which will be changed
let userMap, userPlace, userOriginMarker, userInfoWindow, userSelectedMarker, userAutocomplete, userLocation,
    [userMarkers, userStockists] = [[], []];

// declarate dom element
const findStockistsButton = document.querySelector(selectors.findStockistsButton),
      form = document.querySelector(selectors.form),
      pacError = document.querySelector(selectors.pacError),
      pacInput = document.querySelector(selectors.pacInput),
      pacInputIcon = document.querySelector(selectors.pacInputIcon),
      resetButton = document.querySelector(selectors.resetButton),
      result = document.querySelector(selectors.result),
      resultButton = document.querySelector(selectors.resultButton),
      resultList = document.querySelector(selectors.resultList),
      stockist = document.querySelector(selectors.stockist),
      stockistCount = document.querySelector(selectors.stockistCount);

// find stockist
function findStockists() {
  clearErrorMessage();
  let location = {};

  if (userPlace != null) {
    if (!userPlace.geometry) {
      showErrorMessage(selectors.errorGeometry);
      return;
    }
    else {
      location.lat = userPlace.geometry.location.lat();
      location.lng = userPlace.geometry.location.lng();
    }
  }
  else if (userLocation != null) {
    location.lat = userLocation.lat;
    location.lng = userLocation.lng;
  } else {
    showErrorMessage(selectors.errorMessage);
    return;
  }

  getStockistsForLocation(userMap, userInfoWindow, location.lat, location.lng, form.dataset.brand);
}

// reset search
function resetSearch() {
  stockist.classList.remove(selectors.stockistActiveClass);
  clearSearch();
}

// get user location from geolocation
function getUserLocation() {
  document.body.style.cursor = 'wait';

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      showPosition(position);
      document.body.style.cursor = 'default';
    },
    function(error) {
      if (error.code == error.PERMISSION_DENIED)
        showErrorMessage(selectors.errorGeolocation);
        document.body.style.cursor = 'default';
    });
  } else {
    showErrorMessage(selectors.errorBrowserGeolocation);
  }
}

// Create the map.
function initMap() {
  const apiKey = 'AIzaSyDdPT0odF20dreRXxQTw6DfcfEwK0eKJ6k',
        input = pacInput,
        options = { componentRestrictions: {country: ['gb', 'ie'] },},
        autocomplete = new google.maps.places.Autocomplete(input, options);

  autocomplete.setFields(['address_components', 'geometry', 'name']);

  autocomplete.addListener('place_changed', async () => {
    clearErrorMessage();
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        showErrorMessage(selectors.errorGeometry);
        return;
      }

      findStockistsButton.disabled = false;
      userPlace = place;
      userLocation = null;
      pacInputIcon.classList.remove(selectors.pacInputIconActiveClass);
      findStockists();
      return;
  });

  userAutocomplete = autocomplete;
}

// get near stores
async function getStockistsForLocation(map, infoWindow, lat, lng, brand, bounds) {
  try {
    let response = await fetch(`https://hoq4iah2gc.execute-api.eu-west-2.amazonaws.com/PROD/WestlandStockistsAPI?long=${lng}&lat=${lat}&sku=${pacInput.dataset.scu}`),
        responseText = await response.text();

    resultButton.addEventListener('click', () => {
      showAllResult(lat, lng);
    });

    let stockists = JSON.parse(responseText);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'stockist_search',
      'type': 'product',
      'sku': pacInput.dataset.scu,
      'title': pacInput.dataset.productName,
      'brand': brand,
      'location': pacInput.value
    });

    if (stockists.length > 0) {
      showStockistsOnMap(map, infoWindow, lat, lng, stockists, bounds);
    } else {
      showErrorMessage(selectors.errorMessage);
    }
  } catch(err) {
    showErrorMessage(selectors.errorApiMessage);
    console.log(err);
  }
}

// show stores on the map
function showStockistsOnMap(map, infoWindow, lat, lng, stockists) {
  userStockists = stockists;
  resultList.innerHTML = '';
  const name = stockists[0].stockist_name;
  const distance = stockists[0].stockist_distance_miles > 10 ? Math.round(stockists[0].stockist_distance_miles) + " Miles" : stockists[0].stockist_distance_miles + " Miles";
  let address1 = stockists[0].stockist_address_1;
  if (stockists[0].stockist_address_2) {
    address1 += ", " + stockists[0].stockist_address_2;
  }

  const city = stockists[0].stockist_address_city;
  const county = stockists[0].stockist_address_county;
  const postcode = stockists[0].stockist_address_postalcode;
  const phone = stockists[0].stockist_telephone;
  const position = { lat: stockists[0].stockist_latitude, lng: stockists[0].stockist_longitude };

  let address2 = city;
    if (city && county) {
      address2 += ', ' + county;
    } else if (county) {
      address2 = county;
    }

  const content = `
  <div class="stockistCard stockist-card">
      <h3 class="stockistCard__header">
      <span class="stockistCard__headerTitle">
        ${name}
      </span>
      <span class="stockistCard__headerDistance">
        ${distance}
      </span>
      </h3>
      <div class="stockistCard__info stockist-card-info">
          <div class="stockist-card-address">
              <p>${address1}</p>
              <p>${address2}</p>
              <p>${postcode}</p>
          </div>
          <div class="stockistCard__contact stockist-card-phone">
            ${phone != '' ? `<p class="stockistCard__contactPhone">TEL: ${phone}</p>` : '' }
              <p class="stockistCard__contactLinkWrapper">
                <a class="stockistCard__contactLink" target="_blank" href="https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${position.lat},${position.lng}">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_1864_1502" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                      <rect x="0.5" y="0.5" width="19" height="19" fill="#D9D9D9" stroke="#E3E3E3"/>
                    </mask>
                    <g mask="url(#mask0_1864_1502)">
                      <path d="M8.5 9.5H8V10V11.5H7.5V9.25C7.5 9.17351 7.5211 9.12401 7.57255 9.07255C7.62401 9.0211 7.67351 9 7.75 9H11H11.5V8.5V7.95711L12.7929 9.25L11.5 10.5429V10V9.5H11H8.5ZM9.61772 17.4294L9.61714 17.4292C9.50963 17.3879 9.40117 17.3185 9.29232 17.2092L9.29155 17.2084L2.79155 10.7084L2.79078 10.7077C2.68145 10.5988 2.61207 10.4904 2.57081 10.3829L2.57058 10.3823C2.52355 10.2602 2.5 10.1338 2.5 10C2.5 9.86621 2.52355 9.73984 2.57058 9.61772L2.57081 9.61714C2.61207 9.50963 2.68145 9.40117 2.79078 9.29232L2.79155 9.29155L9.29155 2.79155L9.29232 2.79078C9.40117 2.68145 9.50963 2.61207 9.61714 2.57081L9.61772 2.57058C9.73984 2.52355 9.86621 2.5 10 2.5C10.1338 2.5 10.2602 2.52355 10.3823 2.57058L10.3829 2.57081C10.4904 2.61207 10.5988 2.68145 10.7077 2.79078L10.7084 2.79155L17.2084 9.29155L17.2092 9.29232C17.3185 9.40117 17.3879 9.50963 17.4292 9.61714L17.4294 9.61772C17.4765 9.73984 17.5 9.86621 17.5 10C17.5 10.1338 17.4765 10.2602 17.4294 10.3823L17.4292 10.3829C17.3879 10.4904 17.3185 10.5988 17.2092 10.7077L17.2084 10.7084L10.7084 17.2084L10.7077 17.2092C10.5988 17.3185 10.4904 17.3879 10.3829 17.4292L10.3823 17.4294C10.2602 17.4765 10.1338 17.5 10 17.5C9.86621 17.5 9.73984 17.4765 9.61772 17.4294ZM9.64645 16.8536L10 17.2071L10.3536 16.8536L16.8536 10.3536L17.2071 10L16.8536 9.64645L10.3536 3.14645L10 2.79289L9.64645 3.14645L3.14645 9.64645L2.79289 10L3.14645 10.3536L9.64645 16.8536Z" fill="#00522B" stroke="#E3E3E3"/>
                    </g>
                  </svg>
                  Directions
                </a>
              </p>
          </div>
      </div>
  </div>
  `;

  createResultCard(content, name);

  stockist.classList.add(selectors.stockistActiveClass);
  stockistCount.innerHTML = stockists.length;
}

// create result card
function createResultCard(content, name) {
  const resultCard = document.createElement('div');

  resultCard.className = selectors.resultListCardClass
  resultCard.insertAdjacentHTML("beforeend", content);
  resultList.insertAdjacentElement('beforeend', resultCard);
}

// clear search
function clearSearch() {
  userLocation = null;
  pacInputIcon.classList.remove(selectors.pacInputIconActiveClass);
  pacInput.value = '';
  findStockistsButton.disabled = true;
}

// show all result
function showAllResult(lat, lng) {
  const productInformation = {
    name: pacInput.dataset.productName,
    url: pacInput.dataset.productUrl,
    place: pacInput.value,
    lat: lat,
    lng: lng,
    scu: pacInput.dataset.scu
  }
  // set local storage
  localStorage.setItem('productStockis', JSON.stringify(productInformation));
  // redirect to stockist page
  location.href = `${document.location.origin}${selectors.stockistsPage}`;
}

// show use position on the map
function showPosition(position) {
  clearErrorMessage();
  findStockistsButton.disabled = false;
  const myLatLng = { lat: position.coords.latitude, lng: position.coords.longitude };
  pacInput.value = selectors.geoLocationTitle;
  pacInputIcon.classList.add(selectors.pacInputIconActiveClass);
  userLocation = myLatLng;
  userPlace = null;
}

// show error block and message
function showErrorMessage(msg) {
  pacError.innerHTML = msg;
  stockist.classList.add(selectors.stockistErrorClass);
}

// clear error message and block
function clearErrorMessage() {
  pacError.innerHTML = '';
  stockist.classList.remove(selectors.stockistErrorClass);
}

//  claer input
function clearInput() {
  findStockistsButton.disabled = true;
  pacInput.value = '';
  pacInputIcon.classList.remove(selectors.pacInputIconActiveClass);
  userLocation = null;
}

// add Event listeners
findStockistsButton.addEventListener('click', findStockists);
pacInput.addEventListener('click', clearInput);
pacInputIcon.addEventListener('click', getUserLocation);
resetButton.addEventListener('click', resetSearch);
form.addEventListener('submit', (e) => {
  e.preventDefault();
  if (pacInput.value == "") {
    showErrorMessage(selectors.errorAutocomplete);
    return;
  };
});
